import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import GridContainer from '../global/GridContainer/GridContainer';
import SearchInput from '../../components/SearchInput';
import WorshipLocationItem from './components/WorshipLocationItem';
import WorshipLocationMap from './components/WorshipLocationMap';
import MapView from '../Icons/MapView';

const WorshipLocations = ({
  worshipLocations,
  organisation,
  getUserOrganisation,
  getWorshipLocations,
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [isMapView, setIsMapView] = useState(false);

  useEffect(() => {
    getWorshipLocations({ search: '' });
    getUserOrganisation();
  }, []);


  useEffect(() => {
    const mapView = searchParams.get('mapview') || false;
    setIsMapView(mapView === 'true' ? true : false);
  }, [searchParams]);

  const onMapPressed = () => {
    setIsMapView(!isMapView);
  };

  const onSearch = (searchText) => {
    setSearch(searchText);
    getWorshipLocations({ search: searchText });
  };

  return (
    <div className="worship-locations-container">
      <GridContainer>
        <div className="worship-locations-container--upper">
          <div
            className="worship-locations-container-header-back-link"
            onClick={() => navigate('/home')}
          >
            <FontAwesomeIcon
              icon={['fas', 'chevron-left']}
              className="feed-group-header-back-link-icon"
            />
            {'Go back'}
          </div>
          <h3 className="title m-0">Worship Locations</h3>
          <SearchInput submit={onSearch} placeholder="Search worship locations" />
        </div>
        {isMapView ? (
          <WorshipLocationMap organisation={organisation} worshipLocations={worshipLocations} />
        ) : (
          <div className="worship-locations-container-hub-list">
            {worshipLocations.map((worship) => {
              return (
                <WorshipLocationItem
                  id={worship.id}
                  title={worship.title}
                  imageData={worship.image}
                  description={worship.description}
                  religion={worship.religion_name}
                />
              );
            })}
            {!worshipLocations.length && !search ? (
              <p>No worship locations available at the moment.</p>
            ) : null}
            {!worshipLocations.length && search ? <p>No worship match your search.</p> : null}
          </div>
        )}

        {worshipLocations.length &&
        organisation &&
        organisation.latitude &&
        organisation.longitude ? (
          <div className="worship-locations-container-float" onClick={onMapPressed}>
            <MapView />
            <p className="worship-locations-container-float__text">
              {!isMapView ? 'Map view' : 'List view'}
            </p>
          </div>
        ) : null}
      </GridContainer>
    </div>
  );
};

export default WorshipLocations;
